import { Button, Modal, notification } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import moodboardService from "../../services/moodboard";

import LoadingPercent from "./LoadingPercent";
import AddToBoardModal from "./AddToBoardModal";
import session from "services/session";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

import "./SearchPage.scss";
import VideoPreview from "./VideoPreview";
import styled from "styled-components";
import moment from "moment";
import { swalSuccess } from "utils/swal";

const SearchItem = ({
  isCommercial,
  activeTabId,
  projectId,
  data,
  index,
  activeIndex,
  setActiveIndex,
  activeData,
  searchResults,
}) => {
  const modalRef = useRef();

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [screenGrabs, setScreenGrabs] = useState([]);
  const [listAssets, setListAssets] = useState([]);

  const isLoggedIn = useMemo(() => {
    return session.get("user") ? true : false;
  }, [session]);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const generateScreenGrab = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/ad-forum/generate-screenshot`,
          {
            videoUrl: activeData.asset_original_url,
          }
        );
        setScreenGrabs(
          res.data.map((thumbnail) => {
            return `${process.env.REACT_APP_API_URL}${thumbnail.original}`;
          })
        );
      } catch (e) {
        console.log("e", e);
      } finally {
        setLoading(false);
      }
    };
    if (
      activeData &&
      activeData.asset_type === "video" &&
      isModalOpen &&
      screenGrabs.length === 0
    ) {
      generateScreenGrab();
    }
  }, [activeData, isModalOpen]);

  const onAddToCurrentBoard = async (video) => {
    const addVideo = video ? video : data;
    if (isLoggedIn) {
      try {
        const body = {
          projectId: projectId,
          size: 0,
          tabId: activeTabId,
          fileUrl: addVideo.asset_original_url,
          thumbnailUrl: addVideo.asset_thumbnail.replace(
            "gimscdn.maydream.com",
            "ims.maydream.com"
          ),
          fileName: null,
          fileSize: 0,
          fileKey: null,
          userId: session.get("user").id,
          date: moment().format(),
          type: "video",
        };

        await moodboardService.add(body).then(() => {
          swalSuccess("Add to current board successfully!");
        });
      } catch (e) {
        console.log("error", e);
      }
    } else {
      notification.error({ message: "Please login first" });
    }
  };

  const onAddingVideo = (video) => {
    if (video) {
      if (isLoggedIn) {
        setListAssets([
          {
            fileUrl: video.asset_original_url,
            type: "video",
            thumbnail: video.asset_thumbnail.replace(
              "gimscdn.maydream.com",
              "ims.maydream.com"
            ),
          },
        ]);
        modalRef.current.openModal();
      } else {
        notification.error({ message: "Please login first" });
      }
    } else {
      if (isLoggedIn) {
        setListAssets([
          {
            fileUrl: data.asset_original_url,
            type: "video",
            thumbnail: data.asset_thumbnail.replace(
              "gimscdn.maydream.com",
              "ims.maydream.com"
            ),
          },
        ]);
        modalRef.current.openModal();
      } else {
        notification.error({ message: "Please login first" });
      }
    }
  };

  const onAddScreenGrab = (e, screenGrab) => {
    e.stopPropagation();
    if (isLoggedIn) {
      setListAssets([
        { fileUrl: screenGrab, type: "image", thumbnail: screenGrab },
      ]);
      modalRef.current.openModal();
    } else {
      notification.error({ message: "Please login first" });
    }
  };

  const onShowModal = () => {
    setIsModalOpen(true);
    setActiveIndex(index);
  };

  const goPrevious = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const goNext = () => {
    if (activeIndex < searchResults.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <div className="searchItem">
      {data.asset_type === "video" ? (
        <div className="searchItem" onClick={onShowModal}>
          <VideoPreview className="searchItem" data={data} />
        </div>
      ) : (
        <img
          className="searchItem"
          src={data.asset_thumbnail.replace(
            "gimscdn.maydream.com",
            "ims.maydream.com"
          )}
          onClick={onShowModal}
          alt=""
        />
      )}

      <Button
        className="addBoardBtn"
        type="primary"
        onClick={(e) => {
          e.stopPropagation();
          if (isCommercial) {
            onAddToCurrentBoard();
          } else {
            onAddingVideo();
          }
        }}
      >
        Add To Board
      </Button>

      <Modal
        title={null}
        footer={null}
        wrapClassName="searchItemModal"
        width={"100vw"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={null}
        destroyOnClose
      >
        <ArrowLeftOutlined
          className="backDetailBtn"
          onClick={() => handleCancel()}
        />
        {activeData.asset_type === "video" ? (
          <WrapVideo>
            <div className="col-1 text-center third-view-nav">
              <IconButton
                className={`nav-icon`}
                disabled={activeIndex === 0}
                onClick={goPrevious}
              >
                <ChevronLeft />
              </IconButton>
            </div>
            <ReactPlayer
              width={"100%"}
              height={"100%"}
              // className="search-video"
              url={activeData.asset_original_url}
              controls={true}
            />

            <div className="col-1 text-center third-view-nav">
              <IconButton
                className={`nav-icon`}
                disabled={activeIndex === searchResults.length - 1}
                onClick={goNext}
              >
                <ChevronRight />
              </IconButton>
            </div>
          </WrapVideo>
        ) : (
          <img
            className="search-image"
            src={activeData.asset_original_url}
            alt=""
          />
        )}
        <div className="video-info">
          <div>
            <div className="videoTitle">{activeData.title}</div>
            <div className="videoCampain">{activeData.campaign}</div>
            <div className="contributors">
              {activeData.contributions.map((contributor, index) => (
                <div key={index} className="contributorWrapper">
                  <div className="contributorTitle">
                    {contributor.contribution}:
                  </div>
                  <div className="contributor">{contributor.entity}</div>
                </div>
              ))}
            </div>
          </div>
          <Button
            className="addBoardBtn"
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              onAddingVideo(activeData);
              // if (isCommercial) {
              //   onAddToCurrentBoard(activeData);
              // } else {
              //   onAddingVideo(activeData);
              // }
            }}
          >
            Add To Board
          </Button>
        </div>
        {loading && <LoadingPercent />}
        <div className="screengrabs-list">
          {screenGrabs?.length &&
            screenGrabs.map((screenGrab, index) => (
              <div key={index} className="screenGrab">
                <img className="screenGrab" src={screenGrab} />
                <Button
                  className="addBoardBtn"
                  type="primary"
                  onClick={(e) => onAddScreenGrab(e, screenGrab)}
                >
                  Add To Board
                </Button>
              </div>
            ))}
        </div>
      </Modal>
      <AddToBoardModal ref={modalRef} listAssets={listAssets} />
    </div>
  );
};

export default SearchItem;

const WrapVideo = styled.div`
  display: flex;
  align-items: center;

  .nav-icon {
    color: #ddd;
  }

  .nav-icon svg {
    font-size: 4rem !important;
  }

  .nav-button {
    color: #ddd;
  }

  .nav-button svg {
    font-size: 4rem !important;
  }

  .nav-icon.Mui-disabled {
    color: #3c3c3c;
  }
`;
